import { SuiteManifest } from '../manifest';
import { projectsRoutes } from './routes';
import { projectsNavItems } from './nav';

export const projectsManifest: SuiteManifest = {
  id: 'projects',
  name: 'Projects & Services',
  basePath: '/projects',
  icon: 'briefcase',
  description: 'Projects & Services suite modules and operations.',
  nav: projectsNavItems,
  routes: projectsRoutes,
  requiredPermission: 'projects.project.read',
};

export default projectsManifest;
